import { gql } from '@apollo/client';

export const fetchInvoiceQuery = gql`
  query fetchInvoiceQuery($id: ID!) {
    invoice(id: $id) {
      id
      invoiceNumber
      sourceId
      invoiceNumber
      domain
      status
      createdTimestamp
      billingGroupId
      creditCard {
        last4Numbers
        cardHolderName
        expirationMonth
        expirationYear
        brand
      }
      dunningStatus {
        attemptCount
        paymentRetryDate
        errorCode
        declineCode
        nextPaymentAttempDate
      }
      sourceSystem
      upgradeCredits
      totalDiscount
      memo
      billTo {
        fullName
        organization
        email
        address {
          address1
          address2
          city
          country
          phone
          postalCode
          state
        }
        taxId
      }
      shipTo {
        fullName
        organization
        email
        address {
          address1
          address2
          city
          country
          phone
          postalCode
          state
        }
        taxId
      }
      total
      taxes
      subtotal
      taxes
      taxesPaymentCurrency
      transactionAccountId
      itemsTotal
      partnerAccountId
      partnerName
      paypalAccountEmail
      paymentCurrency
      paymentMethod
      promotionCode
      invoiceDueDays
      dueDate
      purchaseOrderNumber
      lineItems {
        id
        edition
        entitlementId
        unitCount
        entitlementNumber
        cloudSiteHostname
        amount
        subtotal
        description
        cloudSiteId
        platform
        productKey
        startDate
        invoiceLineItemId
        endDate
        promotionItems {
          id
          title
          applicationReason {
            id
            readableName
            customisable {
              id {
                type
                anyOf {
                  readableName
                  id
                }
              }
            }
          }
          purpose {
            reasonCode
            name
            invoiceNote
          }
          benefits {
            duration
            benefitType
            subBenefitType
            value
            iterations
          }
          status
        }
        discounts {
          amount
          type
          percent
          reason
          reasonCode
        }
        entitlement {
          id
          entitlementNumber
          baseProduct
          cloudSiteId
          cloudSiteUrl
          accountId: orgId
          platform
          productId
          productName
          parentSen
          sourceSystem
          billingCycle
          billingStatus
          businessKey: id
        }
        promotionIds
        quantity
        sen
      }
      refunds {
        id
        creditNoteNumber
        currency
        createdDate
        transactionAccountId
        sourceSystem
        memo
        reason
        refundId
        status
        type
        total
        arn
        refundItems {
          id
          invoiceLineItemId
          entitlementId
          quantity
          description
          total
          totalExTax
          totalTax
          taxRate
          taxableAmount
          taxExemptAmount
        }
        requestedBy
      }
      slaCredits {
        amountExTax
        amountIncTax
        createdAt
        creditExternalId
        currency
        currencyExchangeRate
        modifiedAt
        notes
        taxAmount
        taxRate
      }
      pdfLink
      appliedBalance
    }
  }
`;
